import React from 'react';
import { AddressCard } from '../components/AddressCard';
import { MailActionMenu } from '../components/MailActionMenu';
import { PageContainer, PageSection } from '@/components/layout/PageContainer';
import { AddressInfo } from '../types/address';

// Mock data - 可以后续从 API 获取
const mockAddress: AddressInfo = {
    id: '1',
    title: 'Brewster Shipping Center',
    recipientName: 'Baoguang Dai',
    line1: '12 Main St',
    line2: 'Unit #2083',
    city: 'Brewster',
    state: 'NY',
    zipCode: '10509',
};

export const DashboardPage: React.FC = () => {
    // 切换状态测试：'active' | 'pending'
    const addressStatus: 'active' | 'pending' = 'pending';

    return (
        <PageContainer>
            {/* Address Card Section */}
            <PageSection>
                <AddressCard
                    status={addressStatus}
                    address={addressStatus === 'active' ? mockAddress : undefined}
                />
            </PageSection>

            {/* Mail Action Menu Section */}
            <PageSection>
                <MailActionMenu />
            </PageSection>
        </PageContainer>
    );
};
